<template>
    <div>
        <h5 id="services-title" class="section">
            Services and Teaching
        </h5>
        <el-card class="box-card" id="services">
            <p class="service_para">
              Reviewer: IJHCI, TACCESS, UIST '26, NordiCHI '26, MobileHCI '26, CHI '26, ISMAR '26&24, IMWUT '24; CHI '26 poster, ICCV '25 workshop, CSCW '25 poster, SIGGRAPH '24 poster, CHI '24 LBW
            <!-- Reviewer: IMWUT'24, ISMAR'24, SIGGRAPH'24 poster, CHI'24 LBW -->
            </p>
            <el-divider></el-divider>
            <p class="service_para">
              Student volunteer: CHI '25
            </p>
            <el-divider></el-divider>
            <p class="research">
            Teaching Assistant for CS571 (Building User Interfaces) | University of Wisconsin-Madison
            </p>
            <p class="research-time">
            Summer 2026, Spring 2025, Fall 2024, Fall 2023
            </p>
        </el-card>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ServicesSection',
    data() {
      return {
      };
    }
  };
  </script>
  
  <style>
  </style>